import React from 'react';
import { Typography } from '@mui/material';
import { ModalType } from 'entities/modal/model';
import { ECOSYSTEM_LINKS, Icons, ModalSidebar } from 'shared';

export interface ExplorerModalPayload {
  data?: null;
  type: ModalType.Explorer;
  isOpen?: boolean;
}

export const ExplorerModal = React.forwardRef<
  HTMLElement,
  Pick<ExplorerModalPayload, 'data' | 'isOpen'> & { onClose: VoidFunction }
>(({ onClose, isOpen }, ref) => {
  return (
    <ModalSidebar
      isOpen={isOpen}
      ref={ref}
      onClose={onClose}
      title="MainNet Explorer"
      subtitle="The Transparent Public Ledger"
      icon={<Icons.ExplorerDark />}
      link={{
        title: 'Explore Our MainNet',
        link: {
          href: ECOSYSTEM_LINKS.explorer,
          text: ECOSYSTEM_LINKS.explorer,
        },
      }}
    >
      <Typography variant="inherit" color="inherit" fontFamily="inherit">
        The MainNet Explorer is a public dashboard where anyone can see what’s happening on the CratD2C blockchain.
      </Typography>
      <br />
      <Typography variant="inherit" color="inherit" fontFamily="inherit">
        You can track transactions, blocks, wallet addresses, validator performance, and network stats in real time.
      </Typography>
      <br />
      <Typography variant="inherit" color="inherit" fontFamily="inherit">
        It’s a key part of blockchain transparency - nothing is hidden; everything is verifiable.
      </Typography>
    </ModalSidebar>
  );
});
